export const PREPARES_RESET_STATE = 'PREPARES_RESET_STATE';
export const PREPARES_CURRENT_ITEM = 'PREPARES_CURRENT_ITEM';

export const PREPARES_REQUEST_LOADING = 'PREPARES_REQUEST_LOADING';
export const PREPARES_REQUEST_SUCCESS = 'PREPARES_REQUEST_SUCCESS';
export const PREPARES_REQUEST_FAILED = 'PREPARES_REQUEST_FAILED';

export const PREPARES_CURRENT_ACTION = 'PREPARES_CURRENT_ACTION';
export const PREPARES_RESET_ACTION = 'PREPARES_RESET_ACTION';
